<script>
export default {
  name: "advantagessection",

  data: function () {
    return {
      cards: [
        {
          title: 'Doação via celular!',
          description: 'Você não precisa de aplicativo, nem maquininha. Capte doações direto do celular em todos os momentos.',
          imgPath: 'static/cards/phone.svg',
        },
        {
          title: 'Domínio personalizado',
          description: 'Crie um domínio personalizado para sua campanha, sem custo adicional.',
          imgPath: 'static/cards/computer.svg',
        },
        {
          title: 'Taxas sem pegadinhas!',
          description: 'Não há taxas adicionais para transferências de recursos semanais, sistemas de antifraude ou operadora de cartão de crédito.',
          imgPath: 'static/cards/tax.svg',
        },
        {
          title: 'Arquivo de importação',
          description: 'Não perca tempo digitando doações no SPCE, gere arquivos de importação em cliques.',
          imgPath: 'static/cards/file.svg',
        },
        {
          title: 'Sistema antifraude',
          description: 'Conte com um sistema dedicado ao combate de fraudes e ataques.',
          imgPath: 'static/cards/security.svg',
        },
        {
          title: 'Redes sociais',
          description: 'Facilite o compartilhamento de sua campanha nas redes sociais e apps de mensagens.',
          imgPath: 'static/cards/connect.svg',
        },
        {
          title: '15 minutos',
          description: 'É o tempo que você precisa para colocar sua campanha no ar. Gerencie seu conteúdo por conta própria!',
          imgPath: 'static/cards/stopwatch.svg',
        },
        {
          title: 'Homologado no TSE',
          description: '100% de aprovação da prestação de contas do financiamento coletivo dos nossos clientes. Plataforma homologada pelo TSE',
          imgPath: 'static/cards/gavel.svg',
        },
      ],
    }
  },
};
</script>

<template>
  <div class="row">
    <div class="container">
      <section class="section">
        <div class="text-authenticity">
          <h2>
            <span>A melhor plataforma pelo menor custo</span>
          </h2>
        </div>
        <ul class="cards__list">
          <li class="cards__card" v-for="card in cards">
            <img :src="card.imgPath" :alt="card.title" class="cards__image">
            <div class="cards__text">
              <strong>{{ card.title }}</strong>
              <p>{{ card.description }}</p>
            </div>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.row {
  background-color: #214157;
}

h2 {
  text-align: center;
  color: #fff;
  margin-bottom: 2rem;
}

.cards__list {
  display: flex;
  flex-wrap: wrap;
}

.cards__card {
  justify-content: center;
  flex-grow: 1;
  width: 100%;
  padding-top: 3rem;
  margin-right: 1%;
  margin-bottom: 2%;
  text-align: center;
  list-style: none;
  color: #214157;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 6px 6px 7px 0 rgba(0,0,0,.26);

  @media (min-width: 768px) {
    width: 42%;
  }

  @media (min-width: 991px) {
    width: 32%;
  }

  @media (min-width: 1200px) {
    width: 21%;
  }
}

.cards__image {
  margin-bottom: 1.4rem;
  height: 7rem;
}

.cards__text {
  width: 100%;
  padding-right: 1rem;
  padding-bottom: 1.5em;
  padding-left: 1rem;
}
</style>



// WEBPACK FOOTER //
// _source/javascript/components/advantagessection.vue